import { render, staticRenderFns } from "./PendingAit.vue?vue&type=template&id=6a0aa182"
import script from "./PendingAit.vue?vue&type=script&lang=js"
export * from "./PendingAit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports